import { ChangeEvent, FunctionComponent, useContext, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';

import { Routes } from 'types/routes';

import { withVariables } from 'utils/string';

import LocaleContext from 'components/context/Locale';
import Input from 'components/layout/forms/Input';

import StyledComponent from './styles';
import { Props } from './types';

const PublicLayoutBlogsArticleCategoriesAside: FunctionComponent<Props> = ({
    translations,
    categories,
    onSearch,
}) => {
    const [query, setQuery] = useState<string>(null);
    const router = useRouter();

    if (!Array.isArray(categories) || !categories.length) return null;

    const localeContext = useContext(LocaleContext);

    translations = {
        ...localeContext?.translations?.blockArticleCategoriesAside,
        ...(translations || {}),
    };

    return (
        <StyledComponent className="public-layout-blogs-article-categories-aside">
            {onSearch && (
                <div className="list-search">
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            onSearch(query);
                        }}
                    >
                        <Input
                            name="search"
                            type="text"
                            label={translations?.input?.search?.label}
                            placeholder={translations?.input?.search?.placeholder}
                            onChange={(event: ChangeEvent<any>) => setQuery(event?.target?.value)}
                            value={query}
                            decoratorRight={{
                                visible: true,
                                children: (
                                    <a onClick={() => onSearch(query)}>
                                        <FontAwesomeIcon icon={faSearch} />
                                    </a>
                                ),
                            }}
                        />
                    </form>
                </div>
            )}

            <span className="border" />
            {translations?.title && (
                <div
                    className="list-header"
                    dangerouslySetInnerHTML={{ __html: translations?.title }}
                />
            )}
            <div className="list-body">
                <Link
                    href={withVariables(Routes.PublicBlog)}
                    prefetch={false}
                >
                    <div className="list-element">
                        {translations?.mainCategoryLabel}
                    </div>
                </Link>
                {Array.isArray(categories) && categories.map(category => {
                    return (
                        <Link
                            key={category?.id}
                            href={withVariables(Routes.PublicBlogCategory, { articleCategorySlug: category?.locale?.slug })}
                            prefetch={false}
                        >
                            <div
                                className={classnames(
                                    {
                                        'list-element': true,
                                        'list-element-bold': router?.query?.articleCategorySlug === category?.locale?.slug,
                                    }
                                )}
                                key={category?.id}
                                dangerouslySetInnerHTML={{ __html: category?.locale?.name }}
                            />
                        </Link>
                    );
                })}
            </div>
        </StyledComponent>
    );
};

export default PublicLayoutBlogsArticleCategoriesAside;
